module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-triad"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tab-col col-12"
  }, [_c('b-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.data.tabs), function(tab, index) {
    return _c('b-tab', {
      key: index,
      attrs: {
        "title": _vm.tabTitle(index)
      }
    }, [_c('div', {
      staticClass: "tab-wrap"
    }, [_c('ul', {
      staticClass: "tab-list"
    }, _vm._l((tab.groups), function(group, g_index) {
      return _c('li', {
        key: g_index,
        staticClass: "group-list"
      }, [_c('span', {
        staticClass: "group-title"
      }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('ul', {
        staticClass: "item-list"
      }, _vm._l((group.items), function(item, i_index) {
        return _c('li', {
          key: i_index,
          staticClass: "item"
        }, [_c('b-form-checkbox', {
          staticClass: "checkbox",
          attrs: {
            "checked": [_vm.itemValues[((tab.key) + "-" + (item.id))]],
            "value": true,
            "unchecked-value": false
          },
          on: {
            "change": function($event) {
              _vm.handleItemChange(tab.key, group.key, item, $event)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t\t\t\t\t\t\t")])], 1)
      }))])
    }))])])
  }))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8816dba6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/Triad.vue
// module id = 644
// module chunks = 0